import { Controller } from "@hotwired/stimulus";
import { closeSidePanel } from "../../utils/misc";
import { removeTableRow } from "../../components/tables/remove_table_row";
import { notifyError, notifyUpdate } from "../../components/flash_alert";
import { handleHttpResponse } from "../../utils/http_utils";

export default class extends Controller {
  attachmentTypeChanged(event) {
    const payload = event.detail[0];

    handleHttpResponse({
      payload: payload,
      onSuccess: () => {
        const deletedInvoiceId = event.target.dataset.accountableId;
        removeTableRow(deletedInvoiceId);
        notifyUpdate();
        closeSidePanel();
        document.dispatchEvent(new CustomEvent("accountable:typeChanged"));
      },
      onError: () => {
        const { message } = JSON.parse(payload.response);
        notifyError(message);
      },
    });
  }
}
